/**
 * Base implementation of low-level transport. Each low-level transport should implement following methods:
 * <ul>
 *     <li>send(endpoint : String, headers: {}, method : String, params : *[]) : Promise<Object> - performs a network query. </li>
 * </ul>
 */
import generateGuid from 'uuid/v4';
import q from 'q';

export default {
    send: function send(endpoint, headers, method, params) {
        var STICKY_SESSION_HEADER = 'x-gwre-session';
        var manageStickySessionHeader = function manageStickySessionHeader() {
            if (!sessionStorage.getItem(STICKY_SESSION_HEADER)) {
                sessionStorage.setItem(STICKY_SESSION_HEADER, generateGuid());
            }
        };
        var requestCode = generateGuid();
        var deferred = q.defer();
        manageStickySessionHeader();
        var baseHeaders = {
            'Accept': 'application/json',
            'Content-Type': 'application/json;',
            'x-gwre-session': sessionStorage.getItem(STICKY_SESSION_HEADER)
        };
        headers = Object.assign(baseHeaders, headers);
        return fetch(endpoint, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                'id': '' + requestCode,
                'jsonrpc': '2.0',
                method: method,
                params: params
            })
        }).then(function (res) {
            if (!res.ok) {
                return res.json().then(function (data) {
                    deferred.reject({
                        id: data.id,
                        error: data.error
                    });
                    return deferred.promise;
                });
            }
            return res.json().then(function (data) {
                deferred.resolve({
                    id: data.id,
                    result: data.result
                });
                return deferred.promise;
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-transport-js/module.js
// module id = 926
// module chunks = 0